import { UserRole } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { SelectElement, useFormContext, useWatch } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { fetchGroups } from '../../../../api';
import { UsersAddValues } from '../../create/createUserForm.schema';

export function UserGroupField() {
  const { formatMessage } = useIntl();
  const { setValue } = useFormContext();
  const role = useWatch<UsersAddValues>({ name: 'role' });
  const query = useQuery({
    queryKey: ['user-groups'],
    queryFn: fetchGroups,
  });

  useEffect(() => {
    if (role === UserRole.CLIENT_ADMIN) {
      setValue('groupId', 'NONE');
    }
  }, [role]);

  if (role === UserRole.CLIENT_ADMIN) {
    return null;
  }

  return (
    <SelectElement
      name="groupId"
      label={formatMessage({
        id: 'admin.users.form.group.label',
        defaultMessage: 'Grupo',
      })}
      fullWidth
      disabled={query.isLoading}
      options={[
        {
          id: 'NONE',
          label: formatMessage({
            id: 'admin.users.form.group.noGroup',
            defaultMessage: 'Sin grupo',
          }),
        },
        ...(query.data || []).map((group) => ({
          id: group.id,
          label: group.name,
        })),
      ]}
    />
  );
}
